<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="The Lost Girls: A Novel, by Laurie Fox." height="100%" src="images/9780743253574.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?5d3c1bc2